export default __webpack_public_path__ + "static/media/profile_prime.e99fe629.png";